import React, { Component } from 'react';
import { Modal, Radio, Form, message } from 'antd';
import { connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
const mapStateToProps = (rootState) => ({
    approve: rootState.approve,
});
class Allot extends Component {
    constructor(props) {
        super(props);
        this.ok = () => {
            const allot = this.props.form.getFieldsValue(['checked']);
            if (allot.checked) {
                // FixMe 分配
                dispatch.approve.allotCar(allot);
            }
            else {
                message.warning('请选择人员以进行分配');
            }
        };
        this.cancel = () => {
            dispatch.approve.SHOW_ALLOT(false);
        };
        this.state = {};
    }
    render() {
        const { showAllot, allotData } = this.props.approve;
        return (<Modal centered closable={false} onOk={this.ok} onCancel={this.cancel} visible={showAllot} title={'选择分配人员'}>
        <Form.Item label={'发拍人员名单'}>
          {this.props.form.getFieldDecorator('checked')(<Radio.Group options={allotData} onChange={(s) => {
            console.log(s);
        }}/>)}
        </Form.Item>
      </Modal>);
    }
}
export default connect(mapStateToProps)(Form.create({})(Allot));
